import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, TableRow, TableCell, Checkbox, TableHead, TableSortLabel, Grid, } from '@mui/material';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { LatePaymentIntList } from '../components';
import AddEditLatePaymentIntCRU from '../components/LatePaymentIntCRU';
import { DeletePopUp, PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { useParams } from 'react-router';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { deleteLatePaymentInterestApi, getLatePaymentInterestApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from '../../../../hoc';
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getStorage } from '../../../../shared_elements/actionCreators';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { useDispatch, useSelector } from 'react-redux';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const LatePaymentIntrestHd = ({ sortInfo, createSortHandler, bulk, toggleBulkOps, item }) => {
    const tableSorting = (key, name) => (
        <TableSortLabel sx={{ whiteSpace: 'nowrap' }} active={sortInfo?.sort_by === key} direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'} onClick={() => createSortHandler(key)} >
            <span style={{ color: sortInfo?.sort_by === key ? '#496ac5' : 'inherit' }}>{name}</span>
        </TableSortLabel>
    );
    return (
        <TableRow>
            <TableCell className="table-actions-header" sx={{ minWidth: "140px", whiteSpace: 'nowrap' }}>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "late_payment_interest", operationType: ['D'] }}>
                    <Checkbox size='small' sx={{ cursor: 'pointer' }} onChange={(e) => toggleBulkOps(e.target.checked, "bulk", item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                </PermissionWrapper>
                Action(s)
            </TableCell>
            <TableCell sx={{ minWidth: "100px", whiteSpace: 'nowrap' }}>{tableSorting("name", "Name")}</TableCell>
            <TableCell sx={{ minWidth: "100px", whiteSpace: 'nowrap' }}>{tableSorting("sofr", "SOFR(%)")}</TableCell>
            <TableCell sx={{ minWidth: "100px", whiteSpace: 'nowrap' }}>{tableSorting("margin", "Penalty(%)")}</TableCell>
            <TableCell sx={{ minWidth: "120px", whiteSpace: 'nowrap' }}>{tableSorting("interest_index", "Interest Index")}</TableCell>
            <TableCell>{tableSorting("description", "Description")}</TableCell>
            <TableCell sx={{ minWidth: "180px" }}>{tableSorting("days_to_consider", "Days to be Considered")}</TableCell>
        </TableRow>
    );
};

const LatePaymentInterest = () => {
    const dispatch = useDispatch()
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [addEditLatePaymentInt, setAddEditLatePaymentInt] = useState({ mode: "", modal: false, data: null });
    const [latePaymentInterestInfo, setLatePaymentInterestInfo] = useState({ list: [], pagination: null });
    const [deleteLastPaymentInt, setDeleteLastPaymentInt] = useState({ mode: "", modal: false, data: null });
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [uploadfile, setUploadfile] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: "", type: "" });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [isExport, seIsExport] = useState(false)
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [penaltyInterest, setPenaltyInterest] = useState({ modal: false });

    useEffect(() => {
        getLatePaymentInterestList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Late Payment Interest' })
    }, []);


    const getLatePaymentInterestList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getLatePaymentInterestApi(params, query), {})
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus) {
                    setLatePaymentInterestInfo(response?.data?.data);
                }
            })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "late_payment_interest" }))

    }

    const handelDelAttachment = (deleteSlug) => {
        setLoading(true);
        setUploadfile({
            ...uploadfile,
            data: { ...uploadfile.data, attachments: uploadfile.data.attachments.filter(item => item.slug !== deleteSlug) }
        });
        getLatePaymentInterestList("fetch", { per_page: 50 });
    }

    const toggleBulkOps = async (flag, type, item) => {
        try {
            if (type === "bulk") {
                setBulk({ ...bulk, type: "bulk", ids: flag ? item : [] });
            } else {
                setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
        } catch (error) {
            console.error("Error fetching Data!", error);
        }
    }

    const handelDeleteLatePaymentIntrest = () => {
        setLoading(true);
        const idsToDelete = deleteLastPaymentInt?.modal && deleteLastPaymentInt?.data?.id ? [deleteLastPaymentInt?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteLatePaymentInterestApi(params), { ids: idsToDelete })
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Late Payment Interest`, success_msg: response?.data?.message, item_ids: deleteLastPaymentInt?.data || bulk?.ids, response: response?.data })
                    setDeleteLastPaymentInt({ data: null, modal: false });
                    setBulk({ modal: false, ids: [], title: "", type: "" })
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    getLatePaymentInterestList("fetch", {
                        page: latePaymentInterestInfo?.pagination?.current_page || 1,
                        per_page: latePaymentInterestInfo?.pagination?.per_page || 50,
                    });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    trackActivity('Item Deleted', { page_title: `Delete Late Payment Interest`, error_msg: response?.data?.message, item_ids: deleteLastPaymentInt?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' };
        }
        setSortInfo(sortQuery);
        getLatePaymentInterestList('fetch', { ...sortQuery, per_page: latePaymentInterestInfo?.pagination?.per_page || 50 });
    };

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = { ...query, sort: sortInfo.sort, sort_by: sortInfo.sort_by }
        }
        seIsExport(true);
        globalGetService(getLatePaymentInterestApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Late Payment Interest`, page_type: page_type, })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "late_payment_interest",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                getLatePaymentInterestList("fetch ", { per_page: latePaymentInterestInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
            }
        });
        setSlug({})
    };

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="technical" />
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Late Payment Interest" type="technical" />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary">Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "late_payment_interest", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {latePaymentInterestInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button>
                                    </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "late_payment_interest", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'>
                                            <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' color='primary' variant='contained' size='small'
                                                onClick={() => { setAddEditLatePaymentInt({ modal: true, mode: 'add', data: { name: '', sofr: '', margin: '', description: '', daysToBeConsidered: "" } }); handleItemClicked('Add Item Button') }}>Add Late Payment Interest</Button>
                                        </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: latePaymentInterestInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                                <Table className='mui-table-format' stickyHeader size='medium'>
                                    <TableHead>
                                        <LatePaymentIntrestHd
                                            sortInfo={sortInfo} createSortHandler={createSortHandler}
                                            bulk={bulk}
                                            toggleBulkOps={toggleBulkOps}
                                            item={latePaymentInterestInfo?.list} />
                                    </TableHead>
                                    <TableBody>
                                        {
                                            latePaymentInterestInfo?.list?.length > 0 && latePaymentInterestInfo.list.map((item, index) => {
                                                const uploadedFileData = getApiResponse("late_payment_interest", item?.slug);
                                                return (
                                                    <LatePaymentIntList
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData}
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        key={index}
                                                        item={item}
                                                        onDelete={() => {
                                                            setDeleteLastPaymentInt({ modal: true, data: item });
                                                            setBulk({ modal: false, ids: [item], type: "" })
                                                        }}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        onEdit={() => setAddEditLatePaymentInt({ modal: true, mode: 'edit', data: item, })}
                                                        onView={() => setAddEditLatePaymentInt({ modal: true, mode: "view", data: item })}
                                                        viewFile={() => setUploadfile({ modal: true, mode: "file", data: item })}
                                                        toggleBulkOps={toggleBulkOps}
                                                        bulk={bulk}
                                                    />
                                                )
                                            })}
                                    </TableBody>
                                </Table>
                            )}
                            {!skeletonLoader && !latePaymentInterestInfo?.list?.length && <NoRecordFound />}
                        </div>
                        <Paper square>
                            <Pagination
                                pagination={latePaymentInterestInfo?.pagination}
                                onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getLatePaymentInterestList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                                onPageChange={(event, newPage) => { const pageNum = newPage + 1; getLatePaymentInterestList("Pageloader", { page: pageNum, per_page: latePaymentInterestInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }} />
                        </Paper>
                    </Paper>
                </div>
            </Paper>
            {
                bulk.modal ? <DeletePopUp
                    modal={bulk.modal}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? "these" : "this"} record?`}
                    title={`Delete ${bulk?.ids?.length === (latePaymentInterestInfo?.list?.length || 0) ? "All Late payment Interest" : "Selected Late Payment Interest(s)"}`}
                    onToggleModal={() => setBulk({ modal: false, ids: [], title: "", type: "" })}
                    onDeleteRecords={() => handelDeleteLatePaymentIntrest()} /> : null
            }
            {
                uploadfile.modal ?
                    <ShowAttachments
                        getResponseBack={handelDelAttachment}
                        moduleName="LatePaymentInterest"
                        attachmentsData={uploadfile}
                        url="delete-attachment"
                        toggleModalFn={() => setUploadfile({ model: false, data: null, mode: '' })}
                        openAttachment={() => setUploadfile({ modal: true, data: addEditLatePaymentInt?.data })}
                        permissionKey='late_payment_interest'
                        onViewDisabled={addEditLatePaymentInt?.mode === 'view' || uploadfile?.mode === 'view'}
                    /> : null
            }
            {
                addEditLatePaymentInt.modal ?
                    <AddEditLatePaymentIntCRU
                        fileUpload={handleUpload}
                        addEditLatePaymentInt={addEditLatePaymentInt}
                        onToggleModal={() => setAddEditLatePaymentInt({ ...addEditLatePaymentInt, mode: "", modal: false, data: null })}
                        params={params}
                        getLatePaymentInterestList={getLatePaymentInterestList}
                        latePaymentInterestInfo={latePaymentInterestInfo}
                        modeType={addEditLatePaymentInt?.mode}
                        openAttachment={() => setUploadfile({ modal: true, data: addEditLatePaymentInt?.data, mode: 'view' })}
                        getResponseBack={() => {
                            getLatePaymentInterestList('pageLoader', {
                                page: latePaymentInterestInfo?.pagination?.page || 1,
                                per_page: latePaymentInterestInfo?.pagination?.per_page || 10
                            }); setBulk({ modal: false, ids: [], type: '', title: '' })
                        }} /> : null
            }
            {
                deleteLastPaymentInt.modal ? <DeletePopUp
                    modal={deleteLastPaymentInt.modal}
                    title="Delete Late Payment Interest"
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        setDeleteLastPaymentInt({ modal: false, data: null });
                        setBulk({ modal: false, ids: [], type: "" });
                    }}
                    onDeleteRecords={() => handelDeleteLatePaymentIntrest()} /> : null
            }
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"late_payment_interest"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(LatePaymentInterest, { application: 'lease_revamp', feature: 'late_payment_interest', operationType: ['R'], leaseNav: true });